angular.module("app").controller("PagesCreateItemPageController", [
    '$scope',
    'pagesService',
    'pageStatuses',
    'logger',
    'errorHandler',
    '$stateParams',
    'cropperService',
    'preloadedPageData',
    'userStorage',
    'categoryService',
    'aligns',
    'targets',
    'settingsService',
    '$state',
    'slugNameResolver',
    '$timeout',
    'parentPageIds',
    '$rootScope',
    'booleanType',
    'liveDealerClasses',
    '$uibModal',
    'Utils',
    'showSetForAllLang',
    'hiddenGamesService',
    'bannerShowFor',
    'pagesContentRequired',
    'newWindow',
    'androidAppPromoLogoURL',
    'promoDevice',
    'countryCodes',
    'jackpotSources',
    function ($scope, pagesService, pageStatuses, logger, errorHandler, $stateParams, cropperService, preloadedPageData, userStorage, categoryService, aligns, targets, settingsService, $state, slugNameResolver, $timeout, parentPageIds, $rootScope, booleanType, liveDealerClasses, $modal, Utils, showSetForAllLang, hiddenGamesService, bannerShowFor, pagesContentRequired, newWindow, androidAppPromoLogoURL, promoDevice, countryCodes, jackpotSources) {

        var settings = settingsService.getSettings(),
            init;
        $scope.authValues = bannerShowFor.values;
        $scope.showSetForAllLang = showSetForAllLang;
        $scope.backgroundSize = {};
        $scope.userData = userStorage.getUserData();
        $scope.booleanType = booleanType;
        $scope.liveDealerClasses = liveDealerClasses;
        $scope.newWindow = newWindow;
        $scope.parentPageName = preloadedPageData.page.name;
        $scope.countryCodes = countryCodes.data;
        $scope.countryCodes2 = angular.copy(countryCodes.data);
        $scope.jackpotSources = jackpotSources;

        $scope.switches = {};
        $scope.pagesContentRequired = pagesContentRequired;
        $scope.isNameAutocomplete = preloadedPageData.autocomplete;
        $scope.androidAppPromoLogoURLS = androidAppPromoLogoURL;
        function initNames(preloadedPageData) {
            $scope.actualPageNames = angular.copy(preloadedPageData.names || preloadedPageData.pageNames) || null;
            $scope.usedNames = {};
            preloadedPageData.used && preloadedPageData.used.forEach(function (item) {
                $scope.usedNames[item] = true;
            });
            $scope.pageData && ($scope.pageData.name = "");
            $scope.isNameAutocomplete && $scope.autocomplete && $scope.autocomplete.updateOriginalNames && $scope.autocomplete.updateOriginalNames();
            $timeout(function () {
                $scope.$apply();
            });


        }
        initNames(preloadedPageData);

        $scope.aligns = aligns;
        $scope.targets = targets;
        var categoryTitleIdMap = {};
        $scope.languages = settings.skin.languages;
        var tagTitleIdMap = {};
        $scope.tagsTitles = [];
        var typePermissions = {
            'sidebar': 'manageBanners',
            'news': 'manageNews',
            'promo': 'managePromotions',
            'text': 'managePages'
        };
        var goToState = {
            "sidebar": "main.pages.list.banners",
            "category": "main.pages.list.categories",
            "news": "main.pages.list.news",
            "promo": "main.pages.list.promos"
        };

        function getCustomFields(slugName) {
            $scope.fetchingCustomFields = true;
            pagesService.getCustomFields(slugName).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.customFields = response.fields;
                        $scope.customFieldTypes = response.types;
                        $scope.customFieldRules = response.rules;
                        var customeFieldsLength =  $scope.customFields.length;
                        if ($scope.customFieldRules) {
                            Object.keys($scope.customFieldRules).forEach(function (key) {
                                $scope.tooltip[key] = "";
                            })
                        }
                        for(var i = 0; i < customeFieldsLength; ++i){
                            $scope.pageData.customFields.push({
                                    key: $scope.customFields[i],
                                    value: "",
                                }
                            );

                        }
                        $scope.showIdAutocomplete = false;
                        $timeout(function () {
                            $scope.showIdAutocomplete = true;
                        })
                        $scope.fetchingCustomFields = false;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
        }



        (init = function () {
            var CUSTOM_FIELD_CUSTOM_NAME = "live-c-slider";
            $scope.tooltip = {
                "pageTitle": "",
                "description": "",
                "categories": ""
            };
            $scope.pageData = {
                status: pageStatuses[0],
                lang: preloadedPageData.page.lang,
                type: preloadedPageData.page.type,
                align: aligns[0],
                target: targets[0],
                customFields: [],
                meta_description: "",
                new_window: "0",
                image_alt:"",
            };
            if ({'news': 1, 'promo': 1}[$scope.pageData.type] === 1) {
                delete $scope.pageData.new_window;
            }
            if ({'sidebar': 1, 'promo': 1, 'text': 1}[$scope.pageData.type]) {
                $scope.pageData.excluded_countries = [];
                $scope.pageData.included_countries = [];

            }
            if ($scope.pageData.type === 'promo') {
                $scope.pageData.is_optinable = false;
                $scope.pageData.opt_in = "";
                $scope.pageData.device = promoDevice[0].value;
                $scope.promoDevices = promoDevice;
            }

            if($scope.pageData.type === 'sidebar') {
                $scope.pageData.show_for = bannerShowFor.defaultValue;
            }
            $scope.permission = typePermissions[$scope.pageData.type];
            $scope.backgroundSize = {};
            $scope.backgroundSize.backgroundSizeType = '';
            if($scope.actualPageNames && !$scope.isNameAutocomplete) {
                var filteredPageNames = $scope.actualPageNames.filter(function (value) {
                    return !$scope.usedNames[value.id];
                });
                if (filteredPageNames.length > 0) {
                    $timeout(function () {
                        $scope.pageData.name = filteredPageNames[0].name;
                        getCustomFields($scope.pageData.name);

                    }, 50);
                } else {
                    $scope.pageData.name = "";
                }
            } else {
                $scope.pageData.name = "";
                $scope.autocomplete =  $scope.autocomplete || {};
                $scope.autocomplete.initPageNameAutocomplete && $scope.autocomplete.initPageNameAutocomplete();
                if ($scope.isNameAutocomplete) {
                    getCustomFields(preloadedPageData.page.actualNamesPath.split("pageType=")[1]);
                }
            }

            if ($scope.parentPageName === CUSTOM_FIELD_CUSTOM_NAME) {
                getCustomFields($scope.parentPageName);
            } else if (!$scope.actualPageNames) {
                var slugName = slugNameResolver.getSlugName($stateParams.pageId);
                if (slugName !== undefined){
                    getCustomFields(slugName);
                } else {
                    getCustomFields(preloadedPageData.page.name);
                }
            }




            $scope.categoryOptions = {
                page_id: "",
                categories: []
            };
            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };


            $scope.optionalSettings = {
                hideLanguages: true
            };
            $scope.globalOptions = {
                isGlobalActionsAllowed: settings.allowGlobalActions
            };
            $scope.pageStatuses = pageStatuses;
            $scope.page = angular.copy(preloadedPageData.page);
            $scope.page.type === 'news' && $scope.page.setActualBlock && ($scope.pageData.actual = true);
            $scope.draggedImage = "";
            $scope.draggedImageDataUrl = "";
            $scope.imageToLoad = undefined;

            if ($scope.pageData.type === 'text' || $scope.pageData.type === 'sidebar'){
                var pageIds = angular.copy(parentPageIds.parents).reverse();
                pageIds.push($stateParams.pageId);
                $rootScope.breadcrumb = {
                    title: "breadcrumb.pages.edit",
                    url: "#/pages/pageId/edit/detailed",
                    pageIds: pageIds,
                    itemTitle: "breadcrumb.pages.createItem",
                    itemURL: "#/pages/pageId/edit/create/item".replace('pageId', $stateParams.pageId)
                };

                $scope.$on("$destroy", function (event) {
                    $rootScope.breadcrumb = undefined;
                });
            }

            if ($scope.pageData.type == "news" || $scope.pageData.type == "promo") {
                $scope.edit_page_item_form && ($scope.edit_page_item_form.categories.$invalid = $scope.edit_page_item_form.categories.$error.required = true);
                pagesService.getCategories({lang : $scope.pageData.lang, type: "category"}).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.allCategories = angular.copy(response.pages);
                            $("categorySelect").trigger('chosen:updated');
                            var nameMap = {
                                "news": "get_category_index",
                                "promo": "promo"
                            };
                            var currentCategory = $scope.allCategories.filter(function (item) {
                                if (item.name === nameMap[$scope.pageData.type]) {
                                    return true;
                                }
                                return false;
                            });
                            $scope.categoryOptions.page_id = currentCategory.length > 0? currentCategory[0].id: null;
                            if($scope.categoryOptions.page_id) {
                                $scope.handleChangeOfCategory($scope.categoryOptions.page_id);
                            }
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );
                if($scope.pageData.type === 'news') {
                    settings.allowGlobalActions && categoryService.getTags({page_id: $scope.page.id}).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.tagsTitles = angular.copy(response.items).map(function (item) {
                                    tagTitleIdMap[item.title] = item.id;
                                    return item.title;
                                });
                                $("tagsSelect").trigger('chosen:updated');
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    )
                }

            }

        })();

        $scope.tagsOptions = {
            tags: []
        };




        $scope.deleteImage = function () {
            $scope.draggedImage = "";
            $scope.imageToLoad = undefined;
        };

        /**
         * Name change listener function
         */
        $scope.nameChange = function () {
            getCustomFields($scope.pageData.name);
        };

        /**
         * Reset form to untouched and pristine state
         */
        function clearForm() {
            $scope.$emit("force:reset:editor");
            $rootScope.$broadcast("updateDateTimePicker");
            $timeout(function () {

                $scope.edit_page_item_form && $scope.edit_page_item_form.$setPristine();
                $scope.edit_page_item_form && $scope.edit_page_item_form.$setUntouched();
                $scope.checkCategoriesIsEmpty();
                $("#categorySelect").trigger('chosen:updated');
                $("#nameSelect").trigger('chosen:updated');

            }, 100);

        }

        $scope.submitEditPageItemForm = function () {
            if (!$scope.edit_page_item_form.$valid) {
                $scope.isSavePressed = true;
                if (($scope.pageData.type === 'news' || $scope.pageData.type === 'promo') && $scope.categoryOptions.categories.length === 0) {
                    $scope.tooltip.categories = 'validationErrorMessages.fieldRequired';
                }
                return;
            } else {
                $scope.isSavePressed = false;
            }
            $scope.preview(function (dataUrl) {
                delete $scope.pageData.forceTOChange;
                var requestObj = {
                    item: $scope.pageData
                };
                requestObj.item.customFields = requestObj.item.customFields.filter(function (item) {
                    return !!item.value;
                });
                if (requestObj.item.is_optinable !== undefined) {
                    requestObj.item.is_optinable = requestObj.item.is_optinable? 1: 0;
                }
                requestObj.item.page_id = $stateParams.pageId;
                requestObj.item.content = requestObj.item.content && requestObj.item.content.replace(/&nbsp;|\u00a0/g, " ");
                requestObj.item.categories =  $scope.categoryOptions.categories && $scope.categoryOptions.categories.map(function (title) {
                    return categoryTitleIdMap[title];
                });
                if ($scope.pageData.type === "sidebar" || $scope.page.type === "text" || $scope.pageData.type === "news" || $scope.pageData.type === "promo") {
                    !!$scope.vm.fromDate && (requestObj.item.start_date = $scope.vm.fromDate);
                    !!$scope.vm.toDate && (requestObj.item.end_date = $scope.vm.toDate);
                }
                if($scope.pageData.type === 'news' && $scope.tagsOptions.tags.length > 0){
                    requestObj.item.tags = $scope.tagsOptions.tags && $scope.tagsOptions.tags.map(function (value) {
                        return tagTitleIdMap[value]
                    });

                }

                if(dataUrl != $scope.draggedImageDataUrl) {
                    requestObj.item.image = dataUrl;
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl && !$scope.cropped) {
                    delete requestObj.item.image;
                    requestObj.item.media_id = $scope.imageToLoad.id
                }

                !requestObj.item.global && (delete requestObj.item.global);


                if ($scope.page.type != "category" &&  $scope.page.type != "text") {
                    delete requestObj.item.name
                }
                if (requestObj.item.show_for === '1'){
                    requestObj.item.first_deposit = !!requestObj.item.first_deposit;
                }


                if (!{'sidebar': 1, 'text':1}[$scope.page.type]) {
                    delete requestObj.item.action;
                    delete requestObj.item.align;
                    delete requestObj.item.video_link;
                    delete requestObj.item.linktarget
                }

                pagesService.createPageItem(requestObj).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess('global.saved');
                            if (!!preloadedPageData.page.actualNamesPath) {
                                pagesService.getByExternalPath(preloadedPageData.page.actualNamesPath, {page_id: preloadedPageData.page.id}).then(function (namesResponse) {
                                    initNames(namesResponse);
                                    init();
                                    clearForm();

                                    $scope.tagsOptions.tags = [];
                                });
                            }else {
                                init();
                                clearForm();
                                $scope.tagsOptions.tags = [];
                            }
                            $scope.switches = {};
                            $scope.isSavePressed = false;

                        } else {
                            if(response.message && response.message.page_id) {
                                var modalInstance = $modal.open({
                                    templateUrl: "views/templates/modals/editPageItem.html",
                                    controller: "EditPageItemModalController",
                                    resolve: {
                                        parentPageId: function () {
                                            return $stateParams.pageId;
                                        },
                                        pageId: function () {
                                            return response.message.page_id
                                        }
                                    }
                                });
                            } else {
                                errorHandler(response.message)
                            }
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            });
        };

        $scope.handleChangeOfCategory = function (pageId, callback) {
            pagesService.groupCategory({page_id: pageId, count: "all", status: 'published'}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.categoryItems = angular.copy(response.items);
                        categoryTitleIdMap = {};
                        $scope.categoryItemTitles = $scope.categoryItems.map(function (item) {
                            categoryTitleIdMap[item.title] = item.id;
                            return item.title;
                        });
                        callback && callback();

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        $scope.initDateTimestamp = function initDateTimestamp(index) {
            $scope.vm.dateTimestamp = "";
            $scope.handleChangeOfTimestamp = function handleChangeOfTimestamp(dateTime, dateToSave) {
                $scope.pageData.customFields.length > index && ($scope.pageData.customFields[index].value = dateToSave);
            };
        };


        cropperService.call($scope);

        $scope.onCategoryItemSelect
            = $scope.onCategoryItemDeselect
            = $scope.onCategorySelectAll
            = $scope.onCategoryUnselectAll
            = $scope.onTagsItemSelect
            = $scope.onTagsItemDeselect
            = $scope.onTagsSelectAll
            = $scope.onTagsUnselectAll
            = angular.noop;

        function getSelectedCategories (categories) {
            var returnArray = [],
                index = 0;

            while(categories[index]) {
                returnArray.push(categories[index].id);
                index++
            }
            return returnArray
        }
        /**
         * Close edit page
         */
        $scope.closeEditPage = function closeEditPage () {
            if($scope.page.type === 'text' || $scope.page.type === 'sidebar'){
                $state.go('main.pages.editDetailed', {
                    pageId: $scope.page.id
                });
            }else {
                $state.go(goToState[$scope.page.type]);
            }
        }

        /**
         * Remove media image when browsing new image
         */
        $scope.removeMediaImage = function removeMediaImage() {
            $scope.imageToLoad = undefined;
        }
        /**
         * Adding checking for categories is empty then select making required error
         */
        $scope.checkCategoriesIsEmpty = function checkCategoriesIsEmpty() {
            if ({'news':1, 'promo': 1}[$scope.pageData.type]) {
                $scope.edit_page_item_form.categories.$setValidity("categoryNotSelected", $scope.categoryOptions.categories.length > 0);
                if ($scope.categoryOptions.categories.length === 0){
                    $scope.tooltip.categories = 'validationErrorMessages.fieldRequired';
                } else {
                    $scope.tooltip.categories = '';
                }
            }
        };
        /**
         * Initialize categories state
         */
        $scope.initForm = function initForm() {
            if ($scope.pageData.type == "news" || $scope.pageData.type == "promo") {
                $scope.edit_page_item_form.categories.$setValidity("categoryNotSelected", false);
            }
        }

        $scope.$watch("imageToLoad", function (newVal, oldVal) {
            if(newVal && newVal !== oldVal){
                Utils.getBlob($scope.imageToLoad.fileUrl, $scope.load);
            }
        });

        /**
         * Handle switch type custom field change
         * @param $index custom field index
         * @param field name
         */
        $scope.handleSwitchChange = function handleSwitchChange($index, field) {
            $scope.pageData.customFields[$index].value = $scope.switches[field]? "1": "";
        };

        /**
         * Manage categories in news and promo section
         */
        $scope.manageCategories = function manageCategories() {
            var isInitiallyEmpty = $scope.categoryOptions.categories.length === 0;
            var categoryTitleIdMapCopy = angular.copy(categoryTitleIdMap);
            var processResponse = function () {
                $scope.handleChangeOfCategory($scope.categoryOptions.page_id, function () {
                    var reversedCategoryTitleIdMap = Utils.createReverse(categoryTitleIdMap);
                    $scope.categoryOptions.categories = $scope.categoryOptions.categories.map(function (value) {
                        return reversedCategoryTitleIdMap[categoryTitleIdMapCopy[value]];
                    });
                    $scope.categoryOptions.categories = $scope.categoryOptions.categories.filter(function (value) {
                        return categoryTitleIdMap[value] !== undefined;
                    });
                    !isInitiallyEmpty && ($scope.checkCategoriesIsEmpty());
                    $("#categorySelect").trigger('chosen:updated');
                });
            };
            $modal.open({
                templateUrl: "views/pages/manageCategories.html",
                controller: "PagesManageCategoriesController",
                resolve: {
                    categoryPageId: function() {
                        return $scope.categoryOptions.page_id
                    },
                    language: function () {
                        return $scope.pageData.lang;
                    },
                    preloadedCategories: function () {
                        return pagesService.getPageItems({page_id: $scope.categoryOptions.page_id, limit: 25, status: 'published'}).then(
                            function (response) {
                                if (response.status == "ok") {
                                    if (!!response.page.actualNamesPath) {
                                        return pagesService.getByExternalPath(response.page.actualNamesPath, {page_id: $scope.categoryOptions.page_id}).then(
                                            function (namesResponse) {
                                                if (namesResponse.status === "ok") {
                                                    var result = angular.copy(response);
                                                    result.names = angular.copy(namesResponse.pageNames);
                                                    result.used = namesResponse.used;
                                                    return angular.copy(result)
                                                } else {
                                                    return angular.copy(response)
                                                }

                                            },
                                            function () {
                                                return angular.copy(response)
                                            }
                                        )
                                    }
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message)
                                }
                            },
                            function (response) {
                                errorHandler(response.message)
                            }
                        )
                    }
                }
            }).result.then(processResponse, processResponse);
        };
        /**
         * Load providers for select custom field
         */
        $scope.loadProviders = function loadProviders() {
            hiddenGamesService.getProviders().then(function (response) {
                    if (response.status === "ok") {
                        $scope.providers = angular.copy(response.items);
                        $scope.providers.unshift({
                            providerTitle: "",
                            provider: ""
                        });
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                })
        };

        $scope.changeCountries = function changeCountries(isExcluded) {
            var firstKey = isExcluded? 'excluded_countries': 'included_counties';
            var secondKey = isExcluded? 'included_counties': 'excluded_countries';
            if ($scope.pageData[firstKey] && $scope.pageData[firstKey].length > 0 && $scope.pageData[secondKey] && $scope.pageData[secondKey].length > 0) {
                $scope.pageData[secondKey] = [];
            }
        };



    }
]);
